import * as React from "react";
import get from "lodash/get";
import "./CouponCode.css";
import { isEditMode } from "../../utils/sendClickToMerchant";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { copyText } from "../actions/copyText";

export interface CouponCodeProps extends ComponentBaseProps {
  action: string;
  configName: string;
  coupon?: string;
  errorStyle: { [index: string]: string };
  errorContent: string;
  editStatus: string;
  iconStyle: { [index: string]: string };
  loadingStyle: { [index: string]: string };
  status: string;
  style: {};
  timeoutContent: string;
  timeoutStyle: { [index: string]: string };
}

export class CouponCode extends ComponentBase<CouponCodeProps> {
  getEditContent = () => {
    const { editStatus, errorContent, timeoutContent } = this.props;
    switch (editStatus) {
      case "success":
        return "FBUY-20-41921";
      case "error":
        return errorContent || "Something went wrong";
      case "timeout":
        return (
          timeoutContent ||
          "We are processing your request. You will receive an email if you qualify for this offer."
        );
      default:
        return get(this.props, "config.settings.loadingText", "Loading...");
    }
  };

  getContent = () => {
    const { errorContent, timeoutContent } = this.props;

    if (this.state.tempTextReplace) {
      return this.state.tempTextReplace;
    }

    if (isEditMode()) {
      return this.getEditContent();
    }

    switch (this.props.status) {
      case "success":
        return this.props.coupon;
      case "error":
        return errorContent || "Something went wrong";
      case "timeout":
        return (
          timeoutContent ||
          "We are processing your request. You will receive an email if you qualify for this offer."
        );
      default:
        return get(this.props, "config.settings.loadingText", "Loading...");
    }
  };

  getEditStyle = ({ success, error, loading, timeout, defaultStyle }: any) => {
    const { editStatus } = this.props;
    switch (editStatus) {
      case "success":
        return success;
      case "error":
        return error;
      case "loading":
        return loading;
      case "timeout":
        return timeout;
      default:
        return defaultStyle;
    }
  };

  getStyle = () => {
    const {
      action,
      errorStyle = {},
      timeoutStyle = {},
      iconStyle = {},
      loadingStyle = {},
      status,
    } = this.props;

    const style = {
      ...this.props.style,
      cursor: action ? "pointer" : undefined,
    };

    const success = { ...style, cursor: "pointer" };
    const error = { ...style, ...errorStyle };
    const loading = { ...style, ...iconStyle, ...loadingStyle };
    const timeout = { ...style, ...timeoutStyle };

    if (isEditMode()) {
      return this.getEditStyle({
        success,
        error,
        loading,
        timeout,
        defaultStyle: style,
      });
    }

    if (status === "success") {
      return success;
    }

    if (status === "error") {
      return error;
    }

    if (status === "" || status === "pending") {
      return loading;
    }

    if (status === "timeout") {
      return timeout;
    }

    return style;
  };

  onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.onMouseDown(e);

    if (this.props.coupon) {
      copyText({
        text: this.props.coupon || "",
      });
      this.setState({
        tempTextReplace: get(
          this.props,
          "config.settings.copiedText",
          "Copied!"
        ),
      });
      setTimeout(() => this.setState({ tempTextReplace: undefined }), 1000);
    }
  };

  render() {
    const style = this.getStyle();

    return (
      <div
        id={this.props.configName}
        className="CouponCode"
        onDragStart={this.onDragStart}
        onMouseDown={this.onClick}
        style={style as React.CSSProperties}
        aria-label={get(this.props, "label", "")}
        ref={(component) => (this.component = component)}
      >
        {this.getContent()}
      </div>
    );
  }
}
